<template>
  <div class="page-loading">
    <div class="page-main-box">
      <div class="banner-slogan"></div>
      <div class="process-wrap">
        <div :style="{ width : processNum + '%' }" class="process-body">
        </div>
      </div>
      <div class="load-num">loading...{{processNum}}% 领取你的炫酷夜跑装备</div>
      <div class="man-run"></div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import imgLoader from '../assets/scripts/imgLoader.js'

export default {
  data () {
    return {
      processNum: 0
    }
  },
  mounted () {
    imgLoader({
      limit: 5, // 多少张图片同时加载
      Process: (num) => {
        const that = this;
        this.processNum = num
        if (num === 100) {
          setTimeout(() => {
            that.$router.replace('/home')
          }, 100)
        }
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.logo {
  margin: 30px;
  margin-left: 60px;
  width: 137px;
  height: 66px;
  background: url('../assets/images/logo.png') no-repeat;
  background-size: 100%;
}
.page-loading{
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 97;
  position: fixed;
  width: 100%;
  height: 100%;
  min-height: 1217px;
  background:#000 url('../assets/images/bg_page_load.jpg') no-repeat top center;
  .page-main-box {
    width: 557px;
    transform: translate(-50%,-50%);
    -webkit-transform: translate(-50%,-50%);
    top: 50%;
    left: 50%;
    position: absolute;
  }
  .banner-slogan{
    width: 523px;
    height: 203px;
    background: url('../assets/images/banner_slogan.png') no-repeat center center;
    background-size: 100%;
    margin-bottom: 5px;
  }
  .man-run{
    width: 261px;
    height: 55px;
    background: url('../assets/images/load_btn.png') no-repeat;;
    background-size: 100%;
    margin: 0 auto;
    margin-top: 20px;
  }
  .process-wrap {
    background: url('../assets/images/loading_bg.png') no-repeat;;
    background-size: 100%;
    height: 63px;
    width: 557px;
    .process-body {
      background: url('../assets/images/loading_bg_act.png') no-repeat;;
      height: 100%;
    }
  }
  .load-num{
    margin-top: 20px;
    font-size: 24.5px;
    width: 100%;
    text-align: center;
    color: #fff;
  }
}
</style>
